import { createFileRoute } from '@tanstack/react-router';
import { ReimbursementDetailModule } from '@/modules/reimbursement-detail';

export const Route = createFileRoute('/(dashboard)/_dashboard/finance/reimbursement/$id')({
  component: ReimbursementDetailModule,
});
